module.exports = __webpack_public_path__ + "img/node-grid-transparent.f04e44e8.webp";